import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=3cc736d5&scoped=true"
import script from "./Discussion.vue?vue&type=script&lang=js"
export * from "./Discussion.vue?vue&type=script&lang=js"
import style0 from "./Discussion.vue?vue&type=style&index=0&id=3cc736d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc736d5",
  null
  
)

export default component.exports